@if (ticket1 && ticket2 && ticket3) {
  <app-booked-flight-ticket [tickets]="[ticket1, ticket2, ticket3]" [status]="status"
    (copyValue)="copyText($event)" (copyTicketNumber)="copyText($event, 'Ticket copiado')"
    (cancelRequested)="cancelTicket()">
  </app-booked-flight-ticket>
}
